var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"reset-atm-code.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'resetAtmCode.menu.all' | translate}}</a></li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="reset_atm_code.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/reset_atm_code/reset_atm_code.html
// module id = 2764
// module chunks = 1